import axios from 'axios'

const SCENARIO_CODES = ['output', 'added-value', 'export', 'import', 'profit']

// Vue 2 页面状态：概览和详情共用同一次请求，不在浏览器补造月份数值。
export default {
  data() {
    return {
      operationData: null,
      operationLoading: false,
      operationError: '',
      operationDetailsVisible: false
    }
  },
  computed: {
    operationScenario() {
      const scenarios = this.operationData ? this.operationData.scenarios : []
      const code = SCENARIO_CODES[this.tabbarChildIndex1 - 1]
      return scenarios.find(item => item.code === code) || null
    },
    operationUpdatedAt() {
      return this.operationData && this.operationData.updatedAt
        ? this.operationData.updatedAt
        : '暂无数据'
    }
  },
  created() {
    this.loadIndustryOperation()
  },
  beforeDestroy() {
    if (this._operationRequest) this._operationRequest.cancel()
    this._operationRequest = null
  },
  methods: {
    async loadIndustryOperation() {
      if (this._operationRequest) this._operationRequest.cancel()
      const request = axios.CancelToken.source()
      this._operationRequest = request
      this.operationLoading = true
      this.operationError = ''
      this.operationData = null
      try {
        const response = await this.$request2.get('/admin-api/statistics/brain/operation', {
          params: { year: 2026 },
          timeout: 15000,
          cancelToken: request.token
        })
        if (!response || response.code !== 0) {
          throw new Error(response && response.msg ? response.msg : '产业运行数据加载失败')
        }
        if (response.data && !Array.isArray(response.data.scenarios)) {
          throw new Error('产业运行数据格式异常，请稍后重试')
        }
        if (this._operationRequest === request) this.operationData = response.data
      } catch (error) {
        if (!axios.isCancel(error) && this._operationRequest === request) {
          this.operationError = error.response || error.code === 'ECONNABORTED' || error.message === 'Network Error'
            ? '产业运行数据暂时无法加载，请重试'
            : error.message || '产业运行数据加载失败'
        }
      } finally {
        if (this._operationRequest === request) {
          this.operationLoading = false
          this._operationRequest = null
        }
      }
    }
  }
}
